import { DataItem } from 'scrivito'

import { isString } from './isString'

/**
 * This gets the related contactId, dataClassName and type from a relation.
 * Using subjectId decides whether the relation needs to be reversed.
 * @param relation The relation
 * @param subjectId The subjectId to decide whether the relation
 * needs to be reversed (in case of a ContactContactRelation)
 * @returns The related contactId, dataClassName and type from the relation
 */
export const getRelatedContact = (relation: DataItem, subjectId?: string) => {
  const contactIsFather =
    isString(subjectId) && subjectId === relation.get('contact')
  const contactId =
    (!contactIsFather
      ? (relation.get('contact') as string)
      : (relation.get('father') as string)) || ''
  const dataClassName =
    (!contactIsFather
      ? (relation.get('contactEntity') as string)
      : (relation.get('fatherEntity') as string)) || ''
  const type =
    (!contactIsFather
      ? (relation.get('contactType') as string)
      : (relation.get('fatherType') as string)) || ''
  return { contactId, dataClassName, type }
}
